import React from 'react'
import PropTypes from "prop-types"
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap'

const Select = ({ 
  options, value, label, onChange, 
  comment, commentLabel, commentKey, onChangeComment 
}) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <FormControl
      componentClass="select"
      placeholder="select"
      bsSize="small"
      value={value}
      onChange={evt => onChange(evt.target.value)}
    >
      {
        options.map(({ key, text }) => (
          <option key={key} value={key}>{text || key}</option>    
        ))
      }
    </FormControl>
    {
      commentKey && value == commentKey && (
        <FormGroup>
          <ControlLabel>{commentLabel}</ControlLabel>
          <FormControl
            type="text"
            value={comment}
            onChange={evt => onChangeComment(evt.target.value)}
          />
        </FormGroup>
      )
    }
  </FormGroup>
)

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  
  // #TODO better control these proptypes (required sometimes)
  commentLabel: PropTypes.string,
  commentKey: PropTypes.string,
  comment: PropTypes.string,
  onChangeComment: PropTypes.func,
}

Select.defaultProps = {
  commentLabel: "",
  commentValue: "",
  onChangeComment: null
}

export default Select
